import { put, select, call } from 'redux-saga/effects';

import * as actions from '../../actions';

import setQuestionJump from './setQuestionJump';
import updateDecisionFramework from '../updateDecisionFramework/updateDecisionFramework';

export default function*(action) {
  const surveysState = yield select(state => state.surveys);

  let newState = { ...surveysState };

  if (surveysState.activeFlow && !surveysState.activeFlow.flows) {
    const newSurveyStateActiveFlow = {
      question: { ...surveysState.activeFlow }
    };
    action.api('updateQuestion', newSurveyStateActiveFlow);

    if (
      surveysState.activeFlow.matrix &&
      surveysState.activeFlow.matrix.decisionFrameworkType
    ) {
      const {
        surveyWithUpdatedFramework,
        updateRequest
      } = updateDecisionFramework(surveysState.survey, surveysState.activeFlow);
      if (surveyWithUpdatedFramework) {
        newState = {
          ...newState,
          survey: surveyWithUpdatedFramework
        };
        if (updateRequest) {
          yield call(action.api, updateRequest.api, {
            variables: updateRequest.variables
          });
        }
      }
    }
  }

  newState = setQuestionJump(newState, action.jump);
  yield put({ type: actions.SET_NEW_STATE, newState: newState.newState });

  const newActiveFlow = {
    question: {
      ...newState.newState.activeFlow
    }
  };

  action.api('updateQuestion', newActiveFlow);
}
